import { translateEnum } from 'aos-helpers/src/helpers/translations/Translations'
import { EnumValues } from 'enum-values'
import { TFunction } from 'i18next'

import { TaskCategory } from '../TaskCategory'
import { allowedSubcategories } from '../TaskConfig'
import { TaskType } from '../TaskType'
import { BaseTask } from './BaseTask'
import { sortWithOtherLast } from './sortWithOtherLast'

export enum AnimalsTaskType {
    Observation = 'OBSERVATION',
    Confirmation = 'CONFIRMATION',
    Banishment = 'BANISHMENT',
    Kill = 'KILL',
}

export enum AnimalGender {
    FEMALE = 'FEMALE',
    MALE = 'MALE',
}

export enum AnimalAge {
    CALF = 'CALF',
    ADULT = 'ADULT',
}

export const allAnimalAges = EnumValues.getValues<AnimalAge>(AnimalAge)
export const allAnimalGenders = EnumValues.getValues<AnimalGender>(AnimalGender)
export const allAnimalsTaskTypes = EnumValues.getValues<AnimalsTaskType>(AnimalsTaskType).filter(
    q => allowedSubcategories[TaskCategory.Animals].includes(q),
)

export const translateAnimalsTaskType = (t: TFunction) =>
    translateEnum(t)(AnimalsTaskType, 'animals-task-type')
export const translateAnimalGender = (t: TFunction) =>
    translateEnum(t)(AnimalGender, 'animals-gender')
export const translateAnimalAge = (t: TFunction) => translateEnum(t)(AnimalAge, 'animals-age')

export enum AnimalType {
    Bird = 'BIRD',
    Mammal = 'MAMMAL',
    Other = 'OTHER',
}

export const allAnimalTypes = EnumValues.getValues<AnimalType>(AnimalType)
export const translateAnimalType = (t: TFunction) => translateEnum(t)(AnimalType, 'animal-type')

export const sortAnimalsTaskTypes = (types: AnimalsTaskType[], translate: TFunction) =>
    sortWithOtherLast<AnimalsTaskType>(types, translateAnimalsTaskType(translate), () => false)

export const sortAnimalTypes = (types: AnimalType[], translate: TFunction) =>
    sortWithOtherLast<AnimalType>(
        types,
        translateAnimalType(translate),
        type => type === AnimalType.Other,
    )

export interface AnimalSpecie {
    id: number
    animalType: AnimalType
    label: string
    horns: boolean
}

export const sortAnimalSpecies = (species: AnimalSpecie[]) =>
    sortWithOtherLast<AnimalSpecie>(
        species,
        s => s.label,
        () => false,
    )

export interface AnimalsTask extends BaseTask {
    type: TaskType.AnimalPrevention
    animalTaskType: AnimalsTaskType
    animalSpecies: AnimalSpecie
    amount: number
    cartridges: number
    expulsions: number
    gender: AnimalGender
    lifeStage: AnimalAge
    horns: boolean
    amountOfSpikes: number
}
